import { Card, CardActions, CardContent, CardMedia, Button, Typography, Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material"

import StegImg from '../../assets/images/steganography.jpg'


const Steganography = ({ openSteg, setOpenSteg }) => {
  return (
    <>
      <Card sx={{ minWidth: 250, backgroundColor: '#18122B', margin: '1rem' }}>
        <CardMedia
          sx={{ height: 200 }}
          image={StegImg}
          title='Steganography'
        />
        <CardContent>
          <Typography variant='h6' textAlign='center' sx={{ color: '#EDEBF7' }}>
            <strong>Steganography</strong>
          </Typography>
        </CardContent>
        <CardActions sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}>
          <Button
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
            variant="contained"
            onClick={() => setOpenSteg(true)}
          >
            <strong>View More</strong>
          </Button>
        </CardActions>
      </Card>

      <Dialog
        fullWidth
        maxWidth='md'
        open={openSteg}
        onClose={() => setOpenSteg(false)}
      >
        <DialogTitle textAlign='center' sx={{ backgroundColor: "#18122B", color: '#EDEBF7' }}>
          Steganography
        </DialogTitle>
        <DialogContent sx={{ display: 'block', backgroundColor: "#18122B" }}>
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            margin: '2rem 0'
          }}>
            <img src={StegImg} alt='minesweeper' style={{
              maxWidth: '100%',
              width: 700,
              objectFit: 'contain'
            }} />
          </div>

          <Typography variant="body1" sx={{ color: '#EDEBF7' }}>
            Steganography is a full-stack web application that allows users to hide message within an image. To embed the message, user has to upload cover image and message that they want to hide. After uploading and clicking on embed, user can download output image that contains message. To extract the message, user has to switch to extract tab, upload the image that contains the message, click extract button and then download hidden message.
          </Typography>
          <Typography variant="body1" sx={{ color: '#EDEBF7', marginTop: '1rem' }} component='div'>
            Technologies used:
            <ul>
              <li>Javascript</li>
              <li>React.js</li>
              <li>Node.js</li>
              <li>Express.js</li>
            </ul>
          </Typography>
          <Typography variant="h6" sx={{ color: '#EDEBF7', marginTop: '1rem' }}><strong>DEMO</strong>:</Typography>
          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row'
          }}>
            <iframe width="640" height="360" src="https://www.youtube.com/embed/qCWPpSBoJOM" title="Steganography Demo" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
          </div>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#18122B" }}>
          <Button
            onClick={() => setOpenSteg(false)}
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Steganography